import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/** Create a separate HttpClient for translations fetcher which bypasses interceptors */
export function translateHttpLoaderFactory(httpBackend: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpBackend), './assets/i18n/', '-6eee4522-b7f1-46b5-966c-35f96b51646f.json');
}
